// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2v7qA","label":"Section_label__3Uloz","contentWrap":"Section_contentWrap__3zHTx","footer":"Section_footer__3av5h","footerInner":"Section_footerInner__2uzPZ"};